import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  trailerType: null,
  pickup: null,
  delivery: null,
  pickupRadius: null,
  pickupDate: null,
  pickupDateEnd: null,
  deliveryDate: null,
  deliveryDateEnd: null,
  deliveryRadius: null,
  referenceId: null,
  searchType: "market_potential",
};

const currentSearchSlice = createSlice({
  name: "currentSearch",
  initialState,
  reducers: {
    clearCurrentSearch: () => {
      return initialState;
    },
    setCurrentSearch: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const { clearCurrentSearch, setCurrentSearch } = currentSearchSlice.actions;
export default currentSearchSlice.reducer;
